import { layoutMarginSmall, ProductParagraph } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { breakpointWidths } from '../../constants';
import type { StreamName } from '../../types';
import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

export type Props = {
    streamName: StreamName;
    wrapped?: boolean;
};

const Root = styled.div<{ placement: 'left' | 'middle' | 'right' }>`
    align-self: start;
    margin: 0 auto;
    ${({ placement }) => {
        switch (placement) {
            case 'left':
                return css`
                    flex: 0 1 auto;
                    order: 0;
                `;
            case 'middle':
                return css`
                    flex: 0 0 100%;
                    order: 2;
                `;
            case 'right':
                return css`
                    flex: 0 1 auto;
                    order: 4;
                `;
        }
    }}

    @media (max-width: ${breakpointWidths.smallMax}px) {
        margin: ${layoutMarginSmall} auto;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
`;

export const AdsStream: React.FC<Props> = ({ streamName, wrapped }: Props) => {
    const context = useContext(DocumentContext);
    const { articleStorySummaries } = context;
    const placement = wrapped ? 'middle' : streamName === 'popular-now' ? 'left' : 'right';
    const network =
        streamName === 'popular-now'
            ? articleStorySummaries.length
                ? '/30443627/DocPage_Sections_Stream'
                : '/30443627/DocPage_Stream'
            : streamName === 'just-for-you'
            ? '/30443627/DocPage_JustForYou'
            : streamName === 'similar-to'
            ? '/30443627/DocPage_SimilarTo'
            : '';
    return streamName === 'read-more' ? null : (
        <Root placement={placement}>
            <GoogleAdsTemplate
                adSizes={[[300, 250]]}
                idSuffix={streamName.replace(/-/g, '')}
                network={network}
            />
            <ProductParagraph step="negative-2">Advertisement</ProductParagraph>
        </Root>
    );
};
